'use client';

import useWindowSize from '@/lib/useWindowSize';
import { FormLogin } from './FormLogin';
import OrbitaBackground, { OrbitaColors } from './bg/OrbitaBackground';

export const WEBIP_COLORS: OrbitaColors = {
  bg: '#0C2E5E', glow: '#123264', core: '#FFF4DE', mid: '#A8CBF5', rim: '#3D6AA8', accent: '#7CD022',
}

const Page = () => {
  const [, , mobile] = useWindowSize();

  return (
    <div style={{ width: '100vw', height: 'calc(100vh - var(--legacy-banner-h, 0px))', display: 'flex' }}>
      {/* Painel esquerdo */}
      {!mobile && (
        <div
          style={{
            flex: '0 0 55%',
            backgroundColor: '#0b2e5e',
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            padding: '48px 56px',
            color: 'white',
          }}
        >
          {/* <DiagonalLines /> */}
          <OrbitaBackground
            colors={WEBIP_COLORS}
            center={[0.6, 0.3]}
            zoom={1.45}
            count={20000}
            ping
            style={{ position: 'absolute' }}
          />

          {/* Logo */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', zIndex: 1 }}>
            <img src="/logo192.png" alt="WebIP" style={{ height: '28px', width: '28px', objectFit: 'contain' }} />
            <span style={{ fontSize: '1.1rem', fontWeight: '700', letterSpacing: '0.02em' }}>
              Web<span style={{ color: '#7ed321' }}>IP</span>
            </span>
          </div>

          {/* Texto principal */}
          <div style={{ position: 'absolute', top: '52%', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', zIndex: 1 }}>
            <h1
              style={{
                fontSize: 'clamp(2rem, 3.5vw, 2.8rem)',
                fontWeight: '700',
                lineHeight: '1.2',
                marginBottom: '24px',
                color: 'white',
              }}
            >
              A sua rede,
              <br />
              em um único{' '}
              <span style={{ color: '#7ed321' }}>painel.</span>
            </h1>
            <p
              style={{
                fontSize: '1rem',
                color: 'rgba(255,255,255,0.72)',
                lineHeight: '1.7',
                maxWidth: '440px',
                margin: 0,
              }}
            >
              LAN, WAN, VPN e hotspots monitorados em tempo real —
              com políticas de acesso, auditoria e relatórios prontos para a diretoria.
            </p>
          </div>

          {/* Rodapé */}
          <div style={{ display: 'flex', gap: '20px', color: 'rgba(255,255,255,0.45)', fontSize: '0.82rem', zIndex: 1 }}>
            <span>© 2026 WebIP</span>
            <span>gerenciamento seguro</span>
          </div>
        </div>
      )}

      {/* Painel direito */}
      <div
        style={{
          flex: 1,
          backgroundColor: '#ffffff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: mobile ? '24px' : '48px',
        }}
      >
        <div style={{ width: '100%', maxWidth: '420px' }}>
          {mobile && (
            <div style={{ textAlign: 'center', marginBottom: '32px' }}>
              <img src="/logo192.png" alt="Logo WebIP" style={{ height: '64px' }} />
            </div>
          )}
          <FormLogin />
        </div>
      </div>
    </div>
  );
};

export default Page;
